var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgFilter = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 15.2, height: 16 }, props, { children: _jsx("path", { "data-name": "Path 26", d: "M7.15 16H5.6V7.928L0 1.261V0h15.2v1.254L9.867 7.92v5.367Zm-.488-1.067h.046l2.088-2.088v-5.3l5.184-6.48H1.23l5.437 6.474Z" }) }))); };
export default SvgFilter;
